
import { Component, Prop, Vue } from 'vue-property-decorator';
import { initClient } from '../../../../api';
import {
  Group,
  GroupSurveyExtension,
  GroupSurveyExtensionInformationGroupMapping,
  IGroupSurveyExtensionInformationGroupMapping,
  VisitorManagementUiClient,
} from '../../../backend/backendapi';
import { emptyUUID } from '../../../../util';

@Component
export default class InformationGroupSelectCheckBoxes extends Vue {
  @Prop({ required: true })
  groupSurveyExtension!: GroupSurveyExtension;

  private readonly visitorManagementApi = initClient(VisitorManagementUiClient);

  readonly informationGroups: Group[] = [];

  get selectedInformationGroupIds(): string[] {
    this.filterOutInvalidApprovals();
    return this.groupSurveyExtension.informationGroupMappings.map(e => e.informationGroupId);
  }

  set selectedInformationGroupIds(ids: string[]) {
    this.groupSurveyExtension.informationGroupMappings.splice(0);
    this.groupSurveyExtension.informationGroupMappings.push(
        ...ids
            .map(id => GroupSurveyExtensionInformationGroupMapping.fromJS({
              id: emptyUUID(),
              groupSurveyExtensionId: this.groupSurveyExtension.id,
              informationGroupId: id,
            } as IGroupSurveyExtensionInformationGroupMapping)));
  }

  async mounted(): Promise<void> {
    await this.reloadInformationGroups();
  }

  private filterOutInvalidApprovals() {
    const informationGroupIds = new Set(this.informationGroups.map(e => e.id));
    const invalidInformationGroupMappingIndexes = this.groupSurveyExtension.informationGroupMappings
        .map((a, i) => ({ a, i }))
        .filter(({ a, i }) => !informationGroupIds.has(a.informationGroupId))
        .map(({ a, i }) => i)
        .reverse();
    invalidInformationGroupMappingIndexes.forEach(i => {
      this.groupSurveyExtension.informationGroupMappings.splice(i);
    });
  }

  private async reloadInformationGroups() {
    const groups = await this.visitorManagementApi.getInformationGroups();
    this.informationGroups.splice(0);
    this.informationGroups.push(...groups);
  }
}
